const getSelectedFactory = (key, asNumber) => (state) => {
  if (asNumber) {
    return parseInt(state.selected[key])
  }
  return state.selected[key]
}

export const getSelectedTopicId = getSelectedFactory('topicId', true)
export const getSelectedDirectChatHandle = getSelectedFactory('directChatHandle')
export const getSelectedTimelineId = getSelectedFactory('timelineId')
export const getSelectedWidgetQuestionId = getSelectedFactory('widgetQuestionId')
export const getSelectedWelcomeMessageId = getSelectedFactory('welcomeMessageId')

export const getSelectedVideoCollectionId = getSelectedFactory('videoCollectionId')

